import React, { useEffect, useState } from 'react';
import './mopinion.scss';
import { t } from 'i18next';
var MOpinionFeedback = function () {
    var _a = useState(false), showAddBlockerError = _a[0], setShowAddBlockerError = _a[1];
    var id = "Vs5H3Km3un4PX45xluFQH6ocPAhVO1fKlQca0A3l";
    useEffect(function () {
        if (!window.Pastease) {
            var js = document.createElement("script");
            document.getElementsByTagName("head")[0].appendChild(js);
            js.setAttribute("type", "text/javascript");
            js.onload = onMopinionOnLoad;
            js.onerror = onMopinionOnError;
            js.async = true;
            js.setAttribute("src", "//deploy.mopinion.com/js/pastease.js");
        }
    }, []);
    var onMopinionOnError = function () {
        setShowAddBlockerError(true);
    };
    var onMopinionOnLoad = function () {
        var t = setInterval(function () {
            try {
                window.Pastease.load(id);
                clearInterval(t);
                updateBtn();
            }
            catch (e) {
            }
        }, 50);
    };
    var updateBtn = function () {
        var feedbackBtn = document.getElementById("surveySliderBtn");
        if (feedbackBtn) {
            var txt = document.createElement("span");
            txt.innerText = t("TS_core:SendFeedback");
            feedbackBtn === null || feedbackBtn === void 0 ? void 0 : feedbackBtn.appendChild(txt);
        }
        else {
            setTimeout(function () {
                updateBtn();
            }, 100);
        }
    };
    return React.createElement(React.Fragment, null, showAddBlockerError && React.createElement("div", { className: 'opinion-msg' }, t("TS_temp:FeedbackBlockedByAdBlocker")));
};
export default MOpinionFeedback;
